import { lazy } from 'react';

const LazyTriggerEditView = lazy(() => import('./trigger-edit-view'));
export default LazyTriggerEditView;
